/**
 * Generated by orval v8.6.2 🍺
 * Do not edit manually.
 * Marketplace API
 * OpenAPI spec version: 1.0.0
 */

/**
 * * `sub_group` - Sub-group Specification
* `direct_child` - Direct Child Specification
 */
export type ChildSpecType = typeof ChildSpecType[keyof typeof ChildSpecType];


export const ChildSpecType = {
  sub_group: 'sub_group',
  direct_child: 'direct_child',
} as const;
